"use client";

import type { AuthSessionData } from "@cartz/auth";
import { createContext, ReactNode, useContext } from "react";

export interface NonShopSessionContextType {
  isAdmin: boolean;
  authSessionData: AuthSessionData;
}

const NonShopSessionContext = createContext<
  NonShopSessionContextType | undefined
>(undefined);

export const useNonShopSessionContext = () => {
  const context = useContext(NonShopSessionContext);
  if (!context) {
    throw new Error(
      "useNonShopSessionContext must be used within a NonShopSessionContextProvider",
    );
  }
  return context;
};

interface NonShopSessionContextProviderProps {
  children: ReactNode;
  state: NonShopSessionContextType;
}

export const NonShopSessionContextProvider = ({
  children,
  state,
}: NonShopSessionContextProviderProps) => {
  return (
    <NonShopSessionContext.Provider value={state}>
      {children}
    </NonShopSessionContext.Provider>
  );
};
